import { render, staticRenderFns } from "./PublishedSection.vue?vue&type=template&id=1a77f863&scoped=true&"
import script from "./PublishedSection.vue?vue&type=script&lang=js&"
export * from "./PublishedSection.vue?vue&type=script&lang=js&"
import style0 from "./PublishedSection.vue?vue&type=style&index=0&id=1a77f863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77f863",
  null
  
)

export default component.exports